import {useState} from "react";

import {ViolationService} from "violation/service";
import {violation_view_adapter} from "violation/model";
import {plot_view_adapter} from "plot/model";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";

import {SectionCard, SectionCardHeaderAction} from "base/ui/section/components";
import {ViolationForm} from "violation/presentational/form";
import {
    PlotForm,
    PlotInitialDataFormFields,
    PlotFormSearch,
} from "plot/presentational/form";
import {FormContainer} from "base/form/components";
import {PlotBasicDataSection, PlotMapSection} from "plot/presentational";
import {EntityAddButtonGroup} from "base/entity/components/presentational";
import {NoDataContainer} from "base/shared/components";
import EditIcon from "@mui/icons-material/Edit";
import Stack from "@mui/material/Stack";

const ViewOrUpdateViolationPlotContent = ({violation, allowEdit = true}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const plot = violation.plot;

    const [selectedPlot, setSelectedPlot] = useState(null);
    const [mode, setMode] = useState("view");

    const handleSelectPlot = plot => {
        setSelectedPlot(plot);
    };

    const handleCreateFormSubmit = plot => {
        ViolationService.createPlot(violation.id, plot_view_adapter({...plot}))
            .then(createdPlot => {
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const handleEditFormSubmit = () => {
        ViolationService.update(
            violation_view_adapter({...violation, plot: selectedPlot})
        )
            .then(updatedViolation => {
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const secondaryActions = plot?.id
        ? [
              <SectionCardHeaderAction
                  key="edit"
                  name="edit"
                  text="Modificar"
                  icon={<EditIcon />}
                  onClick={() => {
                      setMode("search");
                  }}
              />,
          ]
        : null;

    const getComponent = mode => {
        if (mode === "view") {
            return plot ? (
                <PlotBasicDataSection plot={plot} />
            ) : (
                <NoDataContainer
                    text="Esta infracção ainda não tem uma parcela associada."
                    button={
                        allowEdit && (
                            <EntityAddButtonGroup
                                onAdd={() => setMode("new")}
                                onSearch={() => setMode("search")}
                            />
                        )
                    }
                />
            );
        }
        if (mode === "new") {
            return (
                <PlotForm
                    onSubmit={handleCreateFormSubmit}
                    onCancel={() => {
                        setMode("view");
                    }}
                >
                    <FormContainer>
                        <PlotInitialDataFormFields />
                    </FormContainer>
                </PlotForm>
            );
        }
        if (mode === "search") {
            return (
                <FormContainer>
                    <ViolationForm
                        violation={violation}
                        onSubmit={handleEditFormSubmit}
                        onCancel={() => {
                            setMode("view");
                        }}
                    >
                        <PlotFormSearch onClickSelected={handleSelectPlot} />
                    </ViolationForm>
                </FormContainer>
            );
        }
    };

    return (
        <Stack spacing={1}>
            <SectionCard
                title="Parcela"
                secondaryActions={allowEdit ? secondaryActions : null}
            >
                {getComponent(mode)}
            </SectionCard>
            {mode === "view" && plot && (
                <PlotMapSection plot={plot} editablePlot={false} />
            )}
        </Stack>
    );
};

export default ViewOrUpdateViolationPlotContent;
